import { auth0Client } from "../providers/AuthContext";

export const handleAuthError = (error: any) => {
  // Check if it's an authentication-related error
  if (
    error.error === "login_required" ||
    error.error === "consent_required" ||
    error.error === "interaction_required" ||
    error.error === "missing_refresh_token" ||
    error.message?.includes("Missing Refresh Token") ||
    error.response?.status === 401
  ) {
    console.error("Authentication error detected:", error);

    // Determine the appropriate redirect URL
    let redirectTo = window.location.origin;

    // If we're not on the login page, redirect to login
    if (!window.location.pathname.includes("/login")) {
      redirectTo = window.location.origin + "/login";
    }

    try {
      // Use Auth0's logout method which handles the redirect properly
      auth0Client.logout({
        logoutParams: {
          returnTo: redirectTo,
        },
      });
    } catch (logoutError) {
      console.error("Error during logout:", logoutError);

      // Fallback: manually redirect to login if Auth0 logout fails
      window.location.href = redirectTo;
    }

    return true; // Indicates auth error was handled
  }

  // Handle specific 401 errors that might not have the standard error codes
  if (error.response?.status === 401) {
    console.error("401 Unauthorized error - token may be invalid");

    try {
      // Clear potentially stale auth data
      localStorage.removeItem("auth0.is.authenticated");

      auth0Client.logout({
        logoutParams: {
          returnTo: window.location.origin + "/login",
        },
      });
    } catch (logoutError) {
      console.error("Error during 401 logout:", logoutError);
      window.location.href = window.location.origin + "/login";
    }

    return true;
  }

  // Handle specific 401 errors that might not have the standard error codes
  if (error.response?.status === 401) {
    console.error("401 Unauthorized error - token may be invalid");

    try {
      // Clear potentially stale auth data
      localStorage.removeItem("auth0.is.authenticated");

      auth0Client.logout({
        logoutParams: {
          returnTo: window.location.origin + "/login",
        },
      });
    } catch (logoutError) {
      console.error("Error during 401 logout:", logoutError);
      window.location.href = window.location.origin + "/login";
    }

    return true;
  }
  return false; // Not an auth error
};
